/* eslint-disable unicorn/prefer-global-this */
declare global {
	interface Window {
		analytics: {
			identify: (id: string, data: unknown) => void
			track: (name: string, data?: unknown) => void
		}
	}
}
const { analytics } = window

export default analytics
